import { render, staticRenderFns } from "./el-badge.vue?vue&type=template&id=71e70834"
import script from "./el-badge.vue?vue&type=script&lang=js"
export * from "./el-badge.vue?vue&type=script&lang=js"
import style0 from "./el-badge.vue?vue&type=style&index=0&id=71e70834&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports